import React, { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { PermissionsEnums } from 'src/shared/enums';
import { usePermissions } from 'src/shared/hooks';

interface Props {
  permissions: PermissionsEnums | PermissionsEnums[] | undefined; // if undefined, hook will return false
  children: ReactNode;
  redirectTo?: string;
  strict?: boolean;
}

export const ComponentWithPermissions: FC<Props> = ({ children, permissions = [], redirectTo, strict }) => {
  const hasPermissions = usePermissions(permissions, strict);

  if (!hasPermissions) {
    if (redirectTo) {
      return <Navigate to={redirectTo} />;
    }

    return null;
  }

  return <>{children}</>;
};
